module.exports = __webpack_public_path__ + "img/3.13acc875.png";